import routerOptions0 from "/builds/sbt/smsbat/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  strict: false,
  sensitive: false,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}